<template>
	<b-container class="show-document">
		<div class="doc-body">
			<div class="actions mb-2 mt-2 hidden-print">
				<div class="pull-left">
					<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{ $t('back') }}</b-button>
				</div>
				<div class="pull-right">
					<b-button variant="outline-dark" class="mr-2" @click="print">
						<i class="fa fa-print"></i> Печать Штрихкод
					</b-button>
					<div class="clearfix"></div>
				</div>
				<div class="clearfix"></div>
			</div>
			<div>
				<div class="printElement text-center mt-4" v-for="n in items">
					<p class="text-center info"><b>{{n.barcode}}</b> <b class="ml-2">{{ n.priceUzs }} UZS</b><br/></p>
					<p class="text-center info"> {{ n.itemName }} <br/></p>
					<barcode :value="n.multiBarcode" :options="{ height: '50px',displayValue: false}" tag="svg"></barcode>
					<p style="font-size: 16px" class="barcode"><b>{{ n.multiBarcode }}</b></p>
				</div>
			</div>
		</div>
	</b-container>
</template>

<script>
import { mapState } from 'vuex';
import WhDocument from "../../../../../services/wh-document.service";

export default {
	name: 'BarcodeGenerate',
	data() {
		return {
			items: []
		}
	},
	computed: {},
	methods: {
		async removePageSizeStyle() {
			var el = document.getElementById('stylePrintSizeId');
			if (el) {
				el.remove(); // Removes the div with the 'stylePrintSizeId' id
			}
		},
		async setPageSizeStyle(sizeValue) {
			var css = `@page { size: ${sizeValue}; }`,
			head = document.head || document.getElementsByTagName('head')[0],
			style = document.createElement('style');
			style.type = 'text/css';
			style.media = 'print';
			style.id = 'stylePrintSizeId';
			if (style.styleSheet){
				style.styleSheet.cssText = css;
			} else {
				style.appendChild(document.createTextNode(css));
			}
			head.appendChild(style);
		},
		goBackToFrom() {
			this.$router.back();
		},
		get() {
			if (this.$can('get', 'warehouse-document')) {
				let data = {
					limit: 1000,
					page: 1,
					value: ''
				}
				return WhDocument.getWithPrices(this.$route.params.id, data).then(response => {
					this.items = response.data.whItems;
				}).catch(error => {
					// this.loader = false
				})
			}
		},
		async print(){
			await this.removePageSizeStyle();
			await this.setPageSizeStyle('landscape');
			window.print();
		}
	},
	created() {
		this.get();
	}
}
</script>

<style scoped>
	body {
		background-color: white !important;
	}
	@page {
		margin: 0;
	}
	@media print {
		html, body {
			margin: 0 !important;
			text-align: center;
			padding: 0 !important;
		}
		/* @page { size: landscape; } */
		.hidden-print {
			display: none;
		}
		.printElement {
			margin-top: 2.5% !important;
			margin-bottom: 0 !important;
			text-align: center;
			margin-left: 1% !important;
			page-break-after: always;
			word-break:break-all;
			width: 70mm !important;
			height: 35mm !important;
		}
		.printElement p {
			width: 100%;
			font-family:"Arial Black", Gadget, sans-serif;
			text-align: center;
			color: #000000 !important;
			font-weight: bold;
			page-break-inside: avoid;
		}
		.info {
			font-size: 11px !important;
		}

		.card {
			box-shadow: none;
		}
		svg {
			width: 75mm !important;
			/*margin-top: -1mm;*/
			position: relative;
			bottom: 0;
			left: 0;
		}
		.prices {
			font-size: 20px !important;
		}
	}


	p {
		margin-bottom: 0px;
		font-size: 10px;
	}

	.printElement svg {
		width: 60mm;
		height: 23mm;
	}


</style>
